import { render, staticRenderFns } from "./offerProducts.vue?vue&type=template&id=cedd46d0&scoped=true&"
import script from "./offerProducts.vue?vue&type=script&lang=js&"
export * from "./offerProducts.vue?vue&type=script&lang=js&"
import style0 from "./offerProducts.vue?vue&type=style&index=0&id=cedd46d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cedd46d0",
  null
  
)

export default component.exports